import { helper } from '@ember/component/helper';

export function isTrue([bool]: [unknown] /* , hash*/) {
  if (`${bool}`.toLowerCase() === 'false') {
    return false;
  }
  return Boolean(bool);
}
const isTrueHelper = helper(isTrue);
export default isTrueHelper;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'is-true': typeof isTrueHelper;
  }
}
